/* eslint-disable */
import type { Money } from "../../../common/currency.pb";

/**
 * ///////////////////////////
 * // Configuration Types ////
 * ///////////////////////////
 */
export interface Automation {
  /** A unique identifier */
  token?: string;
  /** The associated customer */
  customer_token?: string;
  /** The version of the automation */
  version?: number;
  /** Whether or not the automation is active */
  status?: AutomationAutomationStatus;
  /** The external event that triggers this automation */
  trigger?: AutomationAutomationTrigger;
  /** How much money should be set aside given the transaction amount */
  allocation_strategy?: AutomationAllocationStrategy;
  /** Where the funds that are being set aside go */
  target?: AutomationAutomationTarget;
  /** When this automation was disabled */
  disabled_at?: Date;
  /** When this automation was enabled */
  enabled_at?: Date;
}

/** Whether the automation is live or not */
export enum AutomationAutomationStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/** What is the event that triggers this automation. */
export enum AutomationAutomationTrigger {
  CASH_CARD_PURCHASE = "CASH_CARD_PURCHASE",
  PAYCHECK_ALLOCATION = "PAYCHECK_ALLOCATION",
}

/**
 * Given the amount of money involved in the precipitating event, how do we
 * decide what amount to invest?
 */
export interface AutomationAllocationStrategy {
  round_up?:
    | AutomationAllocationStrategyRoundUp
    | undefined;
  /** Percentage is from Financial Services Hack Week July '22 Invest Where you Shop Project */
  percentage?: AutomationAllocationStrategyPercentage | undefined;
  fixed?: AutomationAllocationStrategyFixed | undefined;
}

/** Enum with the different allocation strategy types. */
export enum AutomationAllocationStrategyAllocationStrategyType {
  ROUND_UP = "ROUND_UP",
  PERCENTAGE = "PERCENTAGE",
  FIXED = "FIXED",
}

export interface AutomationAllocationStrategyRoundUp {
  /**
   * How much does the round-up get multiplied by? e.g.- on a $2.95
   * purchase with a 3x multiplier, the customer saves $0.15,
   * bringing the purchase up to $3.10.
   */
  multiplier?: number;
}

/** Financial Services Hack Week July '22 Invest Where you Shop Project */
export interface AutomationAllocationStrategyPercentage {
  /** two decimal points of precision (so, 1% would be 100) */
  basis_points?: number;
}

export interface AutomationAllocationStrategyFixed {
  amount?: Money;
}

/** Into what investment/savings vehicle is the money going */
export interface AutomationAutomationTarget {
  /** Where the money is going */
  type?: AutomationAutomationTargetType;
  /** The entity to put the money into (i.e.- which stock) */
  identifier?: string;
  /** The display name of the entity to put the money into. For example, Apple or Bitcoin */
  display_name?: string;
}

export enum AutomationAutomationTargetType {
  INVESTMENT_ENTITY = "INVESTMENT_ENTITY",
  CRYPTOCURRENCY = "CRYPTOCURRENCY",
  /** MERCHANT_INVESTMENT_ENTITY - Financial Services Hack Week July '22 Invest Where you Shop Project */
  MERCHANT_INVESTMENT_ENTITY = "MERCHANT_INVESTMENT_ENTITY",
  SAVINGS_BALANCE = "SAVINGS_BALANCE",
}
